import React, { memo } from 'react';

import { ISegment } from '../../../../models/response/InspectionResponse';
import { Image } from '../../../../ui';

import * as S from './CardElements';

interface IProps {
  item: ISegment;
  routeToDocuments: () => void;
  routeToSegmentDetail: () => void;
}

const Card: React.FC<IProps> = (props) => {
  const { item, routeToDocuments, routeToSegmentDetail } = props;
  switch (true) {
    case item.slug === 'inspection_documents':
      return (
        <S.CarDocument onClick={routeToDocuments}>
          <Image
            src={item?.icon?.url || ''}
            className="!tw-px-0 !tw-object-contain"
            isImageServer={false}
            width={48}
            height={48}
            alt={item.name}
          />
          <S.CarPicturesLabel>{item.name}</S.CarPicturesLabel>
          <span
            className={'icon-Big-Arrows tw-text-lg -tw-rotate-90 tw-absolute tw-right-[20px]'}
          />
        </S.CarDocument>
      );
    case item.slug.includes('feature'):
      return (
        <S.CarDocument onClick={routeToSegmentDetail}>
          <Image
            src={item?.icon?.url || ''}
            className="!tw-px-0 !tw-object-contain"
            isImageServer={false}
            width={48}
            height={48}
            alt={item.name}
          />
          <S.CarPicturesLabel>{item.name}</S.CarPicturesLabel>
          <span
            className={'icon-Big-Arrows tw-text-lg -tw-rotate-90 tw-absolute tw-right-[20px]'}
          />
        </S.CarDocument>
      );
    default:
      return (
        <S.ItemsContainer>
          <S.ItemCard onClick={routeToSegmentDetail}>
            <Image
              src={item?.icon?.url || ''}
              className="!tw-px-0 !tw-object-contain"
              isImageServer={false}
              width={48}
              height={48}
              alt={item.name}
            />
            <S.ItemTitle>{item.name}</S.ItemTitle>
            <S.ItemDefContent>
              <S.ItemDefCount>
                <span className="icon-close-circle"></span>
                {item.component_with_defect_count}
              </S.ItemDefCount>
              <S.ItemPartsCount>
                <span className="icon-tick-circle" />
                {item.component_count - item.component_with_defect_count}
              </S.ItemPartsCount>
            </S.ItemDefContent>
          </S.ItemCard>
        </S.ItemsContainer>
      );
  }
};

export default memo(Card);
